import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDate} from '../../../../../../@casino/lib/getDate';

const useStyles = makeStyles(() => ({
    wrapTitle: {
        paddingLeft: 8,
        paddingBottom: '6px',
        marginTop: 20,
        paddingTop: '4px',
        marginBottom: '8px',
        borderBottom: '1px solid #ccc',
        width: '97%',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingRight: 12,
    },
    title: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        fontSize: '14px',
        lineHeight: '17px',
        userSelect: 'none',
        fontFamily: 'PT Sans,sans-serif',
        color: '#fff',
    },
    arrow: {
        fill: '#fff', 
        width: 10, 
        height: 10
    }
}))

const columns = [
    { id: 'date', label: 'Дата'},
    { id: 'operation', label: `Действие`},
    { id: 'info', label: 'Информация'},
];

const getRows = (operation) => {
    return operation.map((item) => {
        return {
            date: getDate(+item.date_event),
            operation: item.action,
            info: `Сумма ${item.amount}; Баланс ДО ${item.balance_before}; Баланс ПОСЛЕ ${item.balance_after}; 
            Игра ${item.game_uuid}; Транзакция: ${item.client_transaction_id}`
        }
    })
}

export {
    useStyles,
    columns,
    getRows
}